import {
  TRIAGE_ACTIVE_COLOR,
  TRIAGE_DANGER_COLOR,
  TRIAGE_WARNING_ACTIVE_COLOR,
  TRIAGE_WARNING_MARKER_COLOR,
} from '../AssessmentIndex/AssessmentIndex.constants';
import { TriageCategory } from './TriageHeader.types';

export const HIGH_NEED_TRIAGE_CATEGORY: TriageCategory = {
  label: 'High Need',
  activeColor: TRIAGE_ACTIVE_COLOR,
  markerColor: TRIAGE_DANGER_COLOR,
};

export const WARNING_TRIAGE_STYLE = {
  activeColor: TRIAGE_WARNING_ACTIVE_COLOR,
  markerColor: TRIAGE_WARNING_MARKER_COLOR,
};
